/*
 * @Author: FengXiao
 * @Date: 2020-07-01 22:08:41
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-14 13:11:43
 */
import Vue from 'vue';
// import axios from 'axios';
import { Message, MessageBox, Loading,Carousel,CarouselItem, } from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store';
import routerConfig from './config';
import mixins from './mixins';
import './assets/scss/index.scss';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { checkEquipment } from '@/utils';

window.$store = store;

Vue.mixin(mixins);
Vue.use(routerConfig, router);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
// element ui components
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.use(Carousel)
Vue.use(CarouselItem);

if (localStorage.token) {
  store.commit('setToken', localStorage.token);
  store.dispatch('getVipInfo');
}
if (localStorage.user) {
  store.commit('setUser', JSON.parse(localStorage.user));
}
//引入md5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

// 动态加入图标
const iconLink = document.createElement('link');
iconLink.setAttribute('rel', 'icon');
iconLink.setAttribute('href', require('@/assets/imgs/logo.png'));

const iconfontLink = document.createElement('link');
iconfontLink.setAttribute('ref', 'stylesheet');
iconfontLink.setAttribute('href', require('@/assets/icon/iconfont.css'));

let customScrollLink = null;
if (!/macintosh|mac os x/i.test(navigator.userAgent)) {
  customScrollLink = document.createElement('link');
  customScrollLink.setAttribute('ref', 'stylesheet');
  customScrollLink.setAttribute('href', require('@/assets/scss/customScroll.css'));
}

const docHead = document.getElementsByTagName('head');
docHead[0].appendChild(iconLink);
docHead[0].appendChild(iconfontLink);
if (customScrollLink) {
  docHead[0].appendChild(customScrollLink);
}

if (checkEquipment()) {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}
